export default "__VITE_ASSET__BIIEjL3t__"